import React from 'react';

export const ForbiddenPage: React.FC = () => (
  <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center gap-3">
    <h1 className="display-5 fw-bold">403</h1>
    <p className="text-muted mb-1">Acesso negado.</p>
    <p className="text-muted">Você não tem permissão para acessar este recurso.</p>
    <a className="btn btn-outline-primary" href="/">
      Ir para a página inicial
    </a>
  </div>
);
